module.exports = "../../app/cells/components/subscription_expiration_modal_cell.rb";